import { Link } from "@inertiajs/react"
import type { PropsWithChildren } from "react"

import AppLogoIcon from "@/components/app-logo-icon"
import { rootPath } from "@/routes"

interface AuthLayoutProps {
  name?: string
  title?: string
  description?: string
}

export default function AuthSimpleLayout({
  children,
  title,
  description,
}: PropsWithChildren<AuthLayoutProps>) {
  return (
    <div className="bg-background flex min-h-svh flex-col items-center justify-center gap-6 p-6 md:p-10">
      <div className="w-full max-w-sm">
        <div className="flex flex-col gap-8">
          <div className="flex flex-col items-center gap-4">
            <Link
              href={rootPath()}
              aria-label="OKS"
              className="flex flex-col items-center gap-2 font-medium"
            >
              {/*
                OKS-266 — height-only sizing for the canonical OKS lockup
                (3.13:1 aspect). h-12 = 48px tall × ~150px wide; fits the
                centered auth chrome without dominating the page. The
                square wrapper div is gone — a height-constrained mark
                inside a square box would either letterbox (wasted space)
                or distort (forbidden, see app-logo-icon JSDoc).
              */}
              <AppLogoIcon className="mb-1 h-12 text-[var(--foreground)] dark:text-white" />
              <span className="sr-only">{title}</span>
            </Link>

            <div className="space-y-2 text-center">
              <h1 className="text-xl font-medium">{title}</h1>
              <p className="text-muted-foreground text-center text-sm">
                {description}
              </p>
            </div>
          </div>
          {children}
        </div>
      </div>
    </div>
  )
}
